import { memo } from 'react';

import { useTheme } from 'styled-components';
import { GooSpinner } from 'react-spinners-kit';
import { FiChevronDown } from 'react-icons/fi';

import { usePostCommentsQuery } from '@hooks';

import Comment from './Comment';
import * as S from './styles';
import NewCommentInput from './NewCommentInput';

type CommentSectionProps = {
  postId: number;
  visible: boolean;
  inputVisible: boolean;
};

const CommentSection = (props: CommentSectionProps) => {
  const theme = useTheme();

  const { postId, visible: isVisible, inputVisible: isInputVisible } = props;

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    usePostCommentsQuery(postId, isVisible);

  const allComments = data?.pages.flatMap((page) => page.data) ?? [];

  if (!isInputVisible && !isVisible) {
    return null;
  }

  if (!isInputVisible && isLoading) {
    return (
      <S.LoadingWrapper>
        <GooSpinner
          size={1.5}
          sizeUnit="rem"
          color={theme.colors.brand.primary.default}
        />
      </S.LoadingWrapper>
    );
  }

  return (
    <S.Container>
      <NewCommentInput postId={postId} />

      {isVisible && !!allComments.length && (
        <ul>
          {allComments.map((comment) => (
            <Comment key={comment.id} {...comment} />
          ))}
        </ul>
      )}

      {isVisible && hasNextPage && (
        <S.LoadMoreButton
          type="button"
          onClick={() => fetchNextPage()}
          disabled={isFetchingNextPage}
        >
          {isFetchingNextPage ? 'Carregando...' : 'Ver mais comentários'}
          <FiChevronDown />
        </S.LoadMoreButton>
      )}
    </S.Container>
  );
};

export default memo(CommentSection);
